import RouteContainer from 'containers/RouteContainer';
import Component from './containers/ScoresContainer';

export const path = `${DOCUMENTS_PATH}/scores`;
export const navigation = { name: 'scores', id: 'scores.title' };
export const navFatigue = { name: 'fss', id: 'fss.title', nonNavigable: true };
export const navMSIS = { name: 'msis', id: 'msis.title', nonNavigable: true };
export const navMSNQ = { name: 'msnq', id: 'msnq.title', nonNavigable: true };
export const navFSMC = { name: 'fsmc', id: 'fsmc.title', nonNavigable: true };
export const navSDMT = { name: 'sdmt', id: 'sdmt.title', nonNavigable: true };

export default RouteContainer(path, Component);
